import type { PlacedOrderResponse, PlaceOrderRequest } from 'apiConnector/secondary-market/cp-order/model';
import { secondaryMarketAmendActionsFactory } from 'state/secondaryMarket/shared/amend/amend.actions';

export const cpOrderAmendActions = secondaryMarketAmendActionsFactory<
  PlaceOrderRequest,
  PlacedOrderResponse,
  'CP_ORDER'
>('CP_ORDER');

type TypeofCpOrderAmendActions = typeof cpOrderAmendActions;
export type SecondaryMarketCpOrderAmendRequested = ReturnType<
  TypeofCpOrderAmendActions['secondaryMarketAmendRequested']
>;
export type SecondaryMarketCpOrderAmendReceived = ReturnType<TypeofCpOrderAmendActions['secondaryMarketAmendReceived']>;
export type SecondaryMarketCpOrderAmendFailed = ReturnType<TypeofCpOrderAmendActions['secondaryMarketAmendFailed']>;
export type SecondaryMarketCpOrderAmendRejected = ReturnType<TypeofCpOrderAmendActions['secondaryMarketAmendRejected']>;
export type SecondaryMarketCpOrderAmendCollided = ReturnType<TypeofCpOrderAmendActions['secondaryMarketAmendCollided']>;

export type SecondaryMarketCpOrderAmendActions = ReturnType<TypeofCpOrderAmendActions[keyof TypeofCpOrderAmendActions]>;
